import { Control, FieldError, Path } from 'react-hook-form';

import { DropdownField } from '../../components';
import { PULL_SEND_REQUEST_TYPES } from '../constants';

type Option = {
  label: string;
  value: string;
};

const options: Option[] = [
  { label: PULL_SEND_REQUEST_TYPES.BATCH_RATE, value: PULL_SEND_REQUEST_TYPES.BATCH_RATE },
  { label: PULL_SEND_REQUEST_TYPES.AP_TESTING, value: PULL_SEND_REQUEST_TYPES.AP_TESTING },
  { label: 'Rate Compare (Rate Charge Detail)', value: PULL_SEND_REQUEST_TYPES.RATE_COMPARE },
  { label: PULL_SEND_REQUEST_TYPES.GEO_MILEAGE, value: PULL_SEND_REQUEST_TYPES.GEO_MILEAGE },
  { label: PULL_SEND_REQUEST_TYPES.RATING_ANALYSIS, value: PULL_SEND_REQUEST_TYPES.RATING_ANALYSIS },
];

type PullSendRequestTypeFieldProps<TFormValues> = {
  control: Control<TFormValues>;
  name: Path<TFormValues>;
  error?: FieldError;
};

export const PullSendRequestTypeField = <
  TFormValues extends Record<string, unknown>
>({
  control,
  name,
  error,
}: PullSendRequestTypeFieldProps<TFormValues>) => (
  <DropdownField<TFormValues>
    control={control}
    error={error}
    label="Request Type"
    helperText="Select which type of request to send the pulled data to"
    name={name}
    options={options}
  />
);
